import ArrowUpRightIcon from "../../icons/ArrowUpRightIcon";

const PercentChange = ({ value, positive }) => (
  <div
    className={`inline-flex items-center ${
      positive ? "text-[#4ab932]" : "text-error-500"
    }`}
  >
    <span className={positive ? "" : "rotate-180"}>
      <ArrowUpRightIcon />
    </span>
    <span className="text-xs font-medium leading-[19.5px]">
      {Math.abs(value).toFixed(2)}%
    </span>
  </div>
);

export default PercentChange;
